// Change the value of the `variantChangeEvent` variable to the event name that triggers when the variant changes.
// For prestige theme, the event name is `variant:change`
// For other themes, the event name might be different. You can find the event name by inspecting the element that triggers the event when the variant changes.
const variantChangeEvent = 'variant:change';
const klaviyoBisButton = document.getElementById('KlaviyoBisButton');

document.addEventListener(variantChangeEvent, (event) => {
  switch (event.detail.variant.available) {
    case false:
      klaviyoBisButton.hidden = false;
      break;

    default:
      klaviyoBisButton.hidden = true;
      break;
  }
})

class GTCKlaviyoBis extends HTMLElement {

  constructor() {
    super();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.variantChanged = this.variantChanged.bind(this);
  }

  connectedCallback() {
    this.dom = {
      form: this.querySelector('form'),
      infoText: this.querySelector('[data-info]'),
      successText: this.querySelector('[data-success]'),
      errorText: this.querySelector('[data-errors]')
    };

    this.addEventListeners();
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }

  addEventListeners() {
    document.addEventListener(variantChangeEvent, this.variantChanged);
    if (this.dom.form) {
      this.dom.form.addEventListener('submit', this.handleSubmit);
    }
  }

  removeEventListeners() {
    document.removeEventListener(variantChangeEvent, this.variantChanged);
    if (this.dom.form) {
      this.dom.form.removeEventListener('submit', this.handleSubmit);
    }
  }

  variantChanged(event) {
    this.closest('gtc-opener').querySelector('[data-variant-title]').innerText = event.detail.variant.title;
    this.reset();
  }

  reset() {
    this.dom.form.reset();
    this.dom.successText.hidden = true;
    this.dom.errorText.hidden = true;
    this.dom.infoText.hidden = false;
    this.dom.form.hidden = false;
  }

  getVariantFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('variant');
  }

  newsletterSubscription = (listId) => ({
    "list": {
      "data": { "type": "list", "id": listId }
    }
  });

  payloadBackInStock = (email, variant) => (
    {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email,
              },
            },
          },
          channels: ['EMAIL'],
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: `$shopify:::$default:::${ variant }`,
            },
          },
        },
      },
    });

  payloadSubscribe = (email, listID) => ({
    data: {
      type: "subscription",
      attributes: {
        profile: {
          data: {
            type: "profile",
            attributes: {
              email: email,

              subscriptions: {
                email: {
                  marketing: {
                    consent: "SUBSCRIBED"
                  }
                }
              }
            }
          }
        }
      },
      relationships: {
        list: {
          data: {
            type: "list",
            id: listID
          }
        }
      }
    }
  });

  handleSubmit = async (event) => {
    event.preventDefault();

    const formData = new FormData(this.dom.form);
    const email = formData.get('email').toString();
    const variantId = this.getVariantFromUrl() ?? formData.get('variant').toString();
    const apiKey = this.getAttribute('data-api-key');
    const subscribeId = formData.has('subscribeToNewsletter') ? formData.get('subscribeToNewsletter').toString() : null;

    const fetches = [];

    const backInstockFetch = fetch(
      `https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${ apiKey }`,
      {
        method: 'POST',
        headers: {
          accept: 'application/vnd.api+json',
          revision: '2025-04-15',
          'content-type': 'application/vnd.api+json'
        },
        body: JSON.stringify(this.payloadBackInStock(email, variantId)),
      }
    );

    // Subcribe should only be visible if the klaviyo_list_id is set in theme settings
    if (subscribeId) {
      const subscribeFetch = fetch(
        `https://a.klaviyo.com/client/subscriptions?company_id=${ apiKey }`,
        {
          method: 'POST',
          headers: {
            accept: 'application/vnd.api+json',
            revision: '2025-04-15',
            'content-type': 'application/vnd.api+json'
          },
          body: JSON.stringify(this.payloadSubscribe(email, subscribeId)),
        }
      );
      fetches.push(subscribeFetch);
    }

    fetches.push(backInstockFetch);

    try {
      const responses = await Promise.all(fetches);

      // Check if any response is not ok
      const hasError = responses.some(res => !res.ok);

      if (hasError) {
      // Collect all error messages
      const errors = await Promise.all(
        responses.map(async res => {
        if (!res.ok) {
          const json = await res.json();
          return json.errors ? json.errors.map(e => e.detail).join(', ') : res.statusText;
        }
        return null;
        })
      );
      this.writeError(errors.filter(Boolean).join('; '));
      throw new Error(errors.filter(Boolean).join('; '));
      }

      this.dom.successText.hidden = false;
      this.dom.form.hidden = true;
      this.dom.infoText.hidden = true;

    } catch (error) {
      console.error('Error:', error);
    }
  };

  writeError() {
    this.dom.errorText.hidden = false;
    setTimeout(() => {
      this.reset();
    }, 10000);
  }
}

if (!window.customElements.get("gtc-klaviyo-bis")) {
  customElements.define('gtc-klaviyo-bis', GTCKlaviyoBis);
}
